// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage_LoginPage__pPbMZ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.LoginPage_LoginPage__pPbMZ .LoginPage_Form__LxAyP {
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.LoginPage_LoginPage__pPbMZ .LoginPage_Form__LxAyP .LoginPage_Title__CQTZw {
  margin: 0 0 20px;
}
.LoginPage_LoginPage__pPbMZ .LoginPage_Form__LxAyP .LoginPage_Input__D0PZ9 {
  margin: 0 0 10px;
  width: 100%;
}
.LoginPage_LoginPage__pPbMZ .LoginPage_Form__LxAyP .LoginPage_Button__LJeeA {
  margin: 20px 0 0;
  width: 150px;
}
.LoginPage_LoginPage__pPbMZ .LoginPage_Form__LxAyP .LoginPage_ErrorsContainer__wxoDe .LoginPage_ErrorMessage__ZyLgu {
  font-size: 12px;
  line-height: 15px;
  color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginPage/LoginPage.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAIQ;EACI,gBAAA;EACA,WAAA;AAFZ;AAKQ;EACI,gBAAA;EACA,YAAA;AAHZ;AAOY;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AALhB","sourcesContent":["//@use '../../variables.scss';\n\n.LoginPage {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n\n    .Form {\n        width: 400px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        border: 1px solid #ced4da;\n        border-radius: 4px;\n        padding: 20px;\n        box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n\n        .Title {\n            margin: 0 0 20px;\n        }\n\n        .Input {\n            margin: 0 0 10px;\n            width: 100%;\n        }\n\n        .Button {\n            margin: 20px 0 0;\n            width: 150px;\n        }\n\n        .ErrorsContainer {\n            .ErrorMessage {\n                font-size: 12px;\n                line-height: 15px;\n                color: #ff0000;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LoginPage": `LoginPage_LoginPage__pPbMZ`,
	"Form": `LoginPage_Form__LxAyP`,
	"Title": `LoginPage_Title__CQTZw`,
	"Input": `LoginPage_Input__D0PZ9`,
	"Button": `LoginPage_Button__LJeeA`,
	"ErrorsContainer": `LoginPage_ErrorsContainer__wxoDe`,
	"ErrorMessage": `LoginPage_ErrorMessage__ZyLgu`
};
export default ___CSS_LOADER_EXPORT___;
